import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postMotorFourSlice = createSlice({
  name: "postMotorFour",
  initialState,
  reducers: {
    postMotorFourStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postMotorFourSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postMotorFourFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },

  },
});

export const {
  postMotorFourStart,
  postMotorFourSuccess,
  postMotorFourFailure,
  clearError,
  clearMessage,
} = postMotorFourSlice.actions;

export default postMotorFourSlice.reducer;
